import ApiManager from './ApiManager';
import JobManager from "../manager/JobManager";
import {JOB_STATE_COMPLETE, JOB_STATE_FAILED, JOB_STATE_INCOMPLETE} from "../const/job.const";
import {EventBus} from "../events/event.bus";
import {EVENT_JOB_FAIL} from "../events/job.events";
import {useResultPageStore} from "../stores/ResultPageStore";
import {decodeBase64ToImageUrl, encodeImageToBase64} from "../../../../../helper/base64";
import ApiJob from "../model/ApiJob";
import {fabric} from "fabric";


class Base64Manager {
    listener = false;

    constructor() {
    }

    async getImage(url) {
        this.store = useResultPageStore();
        let base64 = this.store.getBase64(url);
        if (typeof base64 === 'undefined' || null === base64) {
            await this.addImage(url);
        }

        return  this.store.getBase64(url).base64;
    }

    async addImage(url) {
        this.store = useResultPageStore();
        let base64Image = await this._getBase64Image(url);
        return this.store.addBase64(url, base64Image);
    }

    async _getBase64Image(url) {
        return new Promise((resolve, reject) => {
            let uri = url;
            encodeImageToBase64(uri).then((base64String) => {
                resolve(decodeBase64ToImageUrl(base64String));
            });
        });
    }
}

export default new Base64Manager();